const baseBackURL = "https://clbs-assessment.com";

module.exports = {
  baseBackURL,
};
